module.exports = __webpack_public_path__ + "static/media/svod-banner-img.17da8a19.jpg";